export default ({keys, server}) => `package com.stripe.example

// A one-field data class used to handle the payment intent response from our backend
data class ServerPaymentIntent(val secret: String)
`;
